module.exports = __webpack_public_path__ + "img/medical-bag.0a9a706d.svg";